import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const currentCarr =
        payload[payload.findIndex((obj) => obj.dataKey === "total_carr")].value * 1000000;
    const netleaseCarr = (payload[0].value * 1000000).toLocaleString();
    const netassetCarr = (payload[1].value * 1000000).toLocaleString();

    const totalYoy = payload[0].payload.total_yoy + "%";
    const netassetYoy =
        payload[0].payload.netasset_yoy == 0 && payload[1].value > 0
            ? "N/A"
            : payload[0].payload.netasset_yoy + "%";
    const netleaseYoy =
        payload[0].payload.netlease_yoy == 0 && payload[0].value > 0
            ? "N/A"
            : payload[0].payload.netlease_yoy + "%";

    return (
        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: 10 }}>
            {/* <p>{typeof netassetCarr }test </p> */}
            <p className="font-bold">{label}</p>
            <p
                className="font-bold"
                style={{ color: "#156082" }}
            >{`Total CARR: $${currentCarr.toLocaleString()}`}</p>

            <p style={{ color: "#156082" }}>NetLease Standalone: {netleaseCarr}</p>
            <p style={{ color: "#5b8fa9" }}>NetAsset Standalone: {netassetCarr}</p>

            <p style={{ color: "#228B22" }}>NetAsset Standalone YoY Growth: {netassetYoy}</p>
            <p style={{ color: "#2f6f8f" }}>NetLease Standalone YoY Growth: {netleaseYoy}</p>
            <p style={{ color: "#66CDAA" }}>TTL Standalone YoY Growth: {totalYoy}</p>
        </div>
    );
};

export default CustomTooltip;
